import React, { useEffect, useState } from 'react'
import GenerateInvoice from 'modules/invoiceCreditNotes/GenerateInvoice';
import { Tabs, Tab } from 'react-bootstrap';
import DownloadInvoiceReport from 'modules/invoiceCreditNotes/DownloadInvoiceReport';
import { useNavigate, useLocation } from 'react-router-dom';

function Invoice() {
    const [key, setKey] = useState('invoice');
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
   
    useEffect(() => {
      const tab = searchParams.get("tab");
      setKey(tab);
    }, []);
  
    const handleTabChange = (tabKey) => {
      setKey(tabKey);
      navigate(`/invoice?tab=${tabKey}`);
    };
  
    return (
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={handleTabChange}
      >
        <Tab eventKey="invoice" title={<span className="custom-tab-title">Generate Invoice</span>}   className='border-bottom border-x mt-3'>
            <GenerateInvoice tab={key} />
        </Tab>
        <Tab eventKey="credit" title={<span className="custom-tab-title">Generate Credit Note</span>}  className='border-bottom mt-3'>
        <GenerateInvoice tab={key} />
        </Tab>
        <Tab eventKey="download" title={<span className="custom-tab-title">Download Invoice Report</span>}  className='border-bottom mt-3'>
        <DownloadInvoiceReport />
        </Tab>
        <Tab eventKey="downloadCaseOrderCount" title={<span className="custom-tab-title">Cases Assignment Order Count Wise Report</span>}  className='border-bottom mt-3'>
        <DownloadInvoiceReport source="agent_case_order_count_wise_assignment_report"/>
        </Tab>
      </Tabs>
    );
}

export default Invoice
